export { useTippingEnabled } from './useTippingEnabled';
